import useUrlState from '@ahooksjs/use-url-state';
import React from 'react';
import ModalRouter, { ModalUrlProps } from './ModalRouter';

const UrlStateModalRouter = (): JSX.Element | null => {
  const [urlState, setUrlState] = useUrlState<ModalUrlProps>({});
  const { modal, ...modalProps } = urlState;

  if (!modal) return null;

  return <ModalRouter modal={modal} {...modalProps} onClose={setUrlState} />;
};

export default UrlStateModalRouter;
